@if (loading()) {
    <div class="flex flex-col gap-4">
        <p-skeleton height="5rem" borderRadius="12px" />
        <div class="grid grid-cols-2 xl:grid-cols-4 gap-4">
            @for (i of [1, 2, 3, 4]; track i) {
                <p-skeleton height="7rem" borderRadius="12px" />
            }
        </div>
        <p-skeleton height="24rem" borderRadius="12px" />
    </div>
} @else if (data(); as d) {
    <fb-page-header [title]="fullName()" [subtitle]="d.venue.name" [backLink]="backLink()" [backLabel]="'ORG_PROFILE' | translate">
        <button actions pButton type="button" severity="secondary" [outlined]="true" [loading]="syncing()" (click)="confirmSync()">
            <i class="ph ph-arrows-down-up"></i>
            <span>{{ 'APPLY_ORG_PROFILE' | translate }}</span>
        </button>
    </fb-page-header>

    <div class="flex items-start gap-3 p-4 mb-4 rounded-md bg-concern-accent border border-concern-accent-border">
        <i class="ph ph-storefront text-concern-accent-dot text-lg"></i>
        <div class="flex flex-col gap-0.5">
            <span class="text-sm font-semibold text-concern-accent-title">{{ 'VENUE_RECORD_TITLE' | translate: { venue: d.venue.name } }}</span>
            <span class="text-sm text-concern-accent-desc">{{ 'VENUE_RECORD_DESC' | translate }}</span>
        </div>
        <div class="ml-auto flex flex-wrap gap-2">
            @if (d.customer.blackListed) {
                <p-tag [value]="'BLOCKED' | translate" severity="danger" icon="ph ph-prohibit" />
            }
            @if (d.customer.excludeCrm) {
                <p-tag [value]="'NO_MARKETING' | translate" severity="secondary" />
            }
        </div>
    </div>

    <section class="grid grid-cols-2 xl:grid-cols-4 gap-4 mb-6">
        <fb-stat-card [label]="'TOTAL_BOOKINGS' | translate" [value]="stats().bookings" icon="ph-calendar-check" />
        <fb-stat-card [label]="'LIFETIME_VALUE' | translate" [value]="utility.currencyTotals(stats().totals, 'lifetimeValue')" icon="ph-coins" />
        <fb-stat-card [label]="'AVERAGE_SPEND' | translate" [value]="utility.currencyTotals(stats().totals, 'averageValue')" icon="ph-receipt" />
        <fb-stat-card
            [label]="'LAST_VISIT' | translate"
            [value]="stats().lastVisit ? (stats().lastVisit | date: 'mediumDate') ?? '' : ('NEVER' | translate)"
            icon="ph-clock" />
    </section>

    <p-tabs class="fb-tabs" [value]="selectedTab()" (valueChange)="selectedTab.set($any($event))">
        <p-tablist>
            <p-tab value="history"><i class="ph ph-clock-counter-clockwise mr-1.5"></i>{{ 'HISTORY' | translate }}</p-tab>
            <p-tab value="profile"><i class="ph ph-user-circle mr-1.5"></i>{{ 'VENUE_PROFILE' | translate }}</p-tab>
        </p-tablist>
        <p-tabpanels>
            <p-tabpanel value="history">
                <div class="rounded-md bg-surface border border-border overflow-hidden">
                    <fb-customer-history [items]="d.history" />
                </div>
            </p-tabpanel>
            <p-tabpanel value="profile">
                <fb-customer-form
                    [customer]="$any(d.customer)"
                    [saving]="saving()"
                    [restrictionsNote]="'RESTRICTIONS_THIS_VENUE_ONLY' | translate"
                    (save)="save($event)" />
            </p-tabpanel>
        </p-tabpanels>
    </p-tabs>
} @else {
    <fb-empty-state
        icon="ph-user-circle-dashed"
        [title]="(errorCode() === 'NO_VENUE_ACCESS' ? 'NO_VENUE_ACCESS' : 'CUSTOMER_NOT_FOUND') | translate"
        [text]="(errorCode() === 'NO_VENUE_ACCESS' ? 'NO_VENUE_ACCESS_TEXT' : 'CUSTOMER_NOT_FOUND_TEXT') | translate">
        <a pButton [outlined]="true" [routerLink]="backLink()">{{ 'BACK' | translate }}</a>
    </fb-empty-state>
}
